import { render, staticRenderFns } from "./addSale.vue?vue&type=template&id=23f804b1&scoped=true"
import script from "./addSale.vue?vue&type=script&lang=js"
export * from "./addSale.vue?vue&type=script&lang=js"
import style0 from "./addSale.vue?vue&type=style&index=0&id=23f804b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f804b1",
  null
  
)

export default component.exports